class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector(".sign-up-popup-modal");
    this.overlay = container.querySelector(".sign-up-popup-overlay");
    this.closeButton = this.popupModal.querySelector(".popup-modal__close");
    this.dismissButton = this.popupModal.querySelector(".popup-modal__dismiss-btn");
    this.form = this.popupModal.querySelector("form.newsletter-form");
    this.emailInput = this.form ? this.form.querySelector('input[type="email"]') : null;
    this.successModal = container.querySelector(".success-popup-modal");
    this.successOverlay = container.querySelector(".success-popup-overlay");
    this.copyButton = this.successModal ? this.successModal.querySelector(".popup-modal__copy-btn") : null;
    this.copySuccessMsg = this.successModal ? this.successModal.querySelector(".popup-modal__success-msg") : null;
    this.successCloseButton = this.successModal ? this.successModal.querySelector(".popup-modal__close") : null;
    this.successDismissButton = this.successModal ? this.successModal.querySelector(".popup-modal__dismiss-btn") : null;
    this.sectionId = this.popupModal.dataset.sectionId;
    this.testMode = this.popupModal.dataset.testMode === "true";
    this.delaySeconds = parseInt(this.popupModal.dataset.delaySeconds, 10) || 8;
    this.delayDays = parseInt(this.popupModal.dataset.delayDays, 10) || 14;
    this.storageKey = "promo-popup-" + window.location.host + "-" + this.sectionId;
    this.subscribedKey = "promo-bar-subscribed-" + window.location.host;
    this.init();
  }

  store(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
  read(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }

  init() {
    this.setupEventListeners();
    if (this.container.querySelector("[data-popup-success]")) {
      this.store(this.subscribedKey, JSON.stringify({ subscribed: true }));
      this.showSuccessPopup();
      return;
    }
    if (this.container.querySelector("[data-popup-error]")) {
      this.showPopup();
      return;
    }
    this.checkAndShowPopup();
  }

  setupEventListeners() {
    this.closeButton.addEventListener("click", () => this.closePopup());
    if (this.dismissButton) this.dismissButton.addEventListener("click", () => this.closePopup());
    this.overlay.addEventListener("click", () => this.closePopup());
    if (this.copyButton) this.copyButton.addEventListener("click", () => this.handleCopyCode());
    if (this.successCloseButton) this.successCloseButton.addEventListener("click", () => this.closeSuccessPopup());
    if (this.successDismissButton) this.successDismissButton.addEventListener("click", () => this.closeSuccessPopup());
    if (this.successOverlay) this.successOverlay.addEventListener("click", () => this.closeSuccessPopup());
    if (this.form && this.emailInput) {
      this.form.addEventListener("submit", (e) => {
        const v = (this.emailInput.value || "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
          e.preventDefault();
          this.emailInput.setCustomValidity("Please enter a valid email.");
          this.emailInput.reportValidity();
          setTimeout(() => this.emailInput.setCustomValidity(""), 3000);
        }
      });
    }
  }

  checkAndShowPopup() {
    if (this.testMode) return;
    if (this.read(this.subscribedKey)) return;
    const stored = this.read(this.storageKey);
    if (stored) {
      try {
        if (new Date(JSON.parse(stored).next_display_date) > new Date()) return;
      } catch (e) {}
    }
    setTimeout(() => this.showPopup(), this.delaySeconds * 1000);
  }

  showPopup() {
    this.popupModal.classList.add("popup-modal--active");
    this.overlay.classList.add("popup-overlay--active");
  }

  closePopup() {
    this.popupModal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
    if (!this.testMode) {
      const next = new Date(Date.now() + this.delayDays * 86400000).toISOString();
      this.store(this.storageKey, JSON.stringify({ next_display_date: next, dismissed: true }));
    }
  }

  showSuccessPopup() {
    if (!this.successModal) return;
    this.popupModal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
    this.successModal.classList.add("popup-modal--active");
    this.successOverlay.classList.add("popup-overlay--active");
  }

  closeSuccessPopup() {
    if (!this.successModal) return;
    this.successModal.classList.remove("popup-modal--active");
    this.successOverlay.classList.remove("popup-overlay--active");
  }

  async handleCopyCode() {
    const input = this.successModal.querySelector("#DiscountCode--" + this.sectionId);
    if (!input) return;
    try { await navigator.clipboard.writeText(input.value); }
    catch (e) { input.select(); document.execCommand("copy"); }
    if (this.copySuccessMsg) {
      this.copySuccessMsg.style.display = "block";
      setTimeout(() => { this.copySuccessMsg.style.display = "none"; }, 3000);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-section-type="newsletter-popup"]').forEach(function (el) {
    new PromoPopup(el.closest("section, .shopify-section") || document.body);
  });
});
